<template>
  <el-dialog
      custom-class="wecat-login-dialog"
      width="400px"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
  >
    <login-area class="wecat-login-area" :type="type" :redirect="redirect" />
  </el-dialog>
</template>

<script>
import loginArea from "./login";

export default {
  components: {
    loginArea,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      required: true,
    },
    redirect: {
      type: String,
      default: "/",
    }
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  watch: {
    visible(val) {
      if (val === this.dialogVisible) {
        return
      }
      this.dialogVisible = val
    },
    dialogVisible(val) {
      if (val === this.visible) {
        return
      }
      this.$emit("update:visible", val)
    },
  },
  methods: {}
}
</script>

<style lang="scss">
.wecat-login-dialog {
  .el-dialog__body {
    padding: 0;
  }
}
</style>

<style lang="scss" scoped>
.wecat-login-area {
}
</style>